import { useState, useEffect } from 'react';
import TBLOGO from "../../../assets/TB-LoGO.webp";

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Support', href: '#amc' },
  { label: 'Contact', href: '#contact' },
];

const LOGO_URL = TBLOGO;

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCTA = () => {
    setMobileOpen(false);
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white/90 backdrop-blur-xl shadow-[0_1px_3px_rgba(0,22,74,0.06)] border-b border-background-200/60"
    >
      <nav className="max-w-site mx-auto px-4 md:px-6 h-[88px] md:h-[96px] flex items-center justify-between">
        <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }} className="flex items-center flex-shrink-0">
          <img
            src={LOGO_URL}
            alt="TechBridge Systems & Solutions"
            className="h-[70px] w-auto object-contain"
            draggable="false"
          />
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="font-label text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap relative group"
            >
              {link.label}
              <span className="absolute bottom-[-4px] left-0 w-0 h-[2px] bg-primary-500 rounded-full transition-all duration-300 group-hover:w-full"></span>
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-4">
          <button
            onClick={handleCTA}
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-xl font-label text-sm font-semibold transition-all duration-300 cursor-pointer group hover:shadow-lg hover:shadow-primary-500/20 hover:-translate-y-0.5"
            style={{ backgroundColor: '#0167F8', color: '#FFFFFF', padding: '10px 22px' }}
          >
            Get IT Support
            <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
          </button>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors text-foreground-950"
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 top-[88px] bg-white/95 backdrop-blur-xl z-40 animate-fadeIn">
          <div className="flex flex-col px-6 pt-6 pb-8 gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="font-heading text-lg font-semibold text-foreground-950 py-3 border-b border-background-200 hover:text-primary-500 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={handleCTA}
              className="mt-4 whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-xl font-label text-sm font-semibold w-full transition-all duration-200 cursor-pointer group hover:shadow-lg hover:shadow-primary-500/20"
              style={{ backgroundColor: '#0167F8', color: '#FFFFFF', padding: '14px 24px' }}
            >
              Get IT Support
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
            </button>
          </div>
        </div>
      )}
    </header>
  );
}